import { FC, useEffect, useState } from "react";
import firebase from "firebase/app"

import "../styles/Header.css"
import { auth } from "../firebase";

interface HeaderProps {
    user: any
}

const Header: FC<HeaderProps> = ({user}) => {
    const [hideSingInMessage , setHideSingInMessage] = useState(false)

    const signInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider()
        auth.signInWithPopup(provider)
    }

    return (
        <header id="header">
            <h1 className="header-text">Task Tracker</h1>

            <div className="user">
                {user ? 
                <div className="logged-in">
                    <h2>Welcome {user.displayName}</h2>
                    <button onClick={() => auth.signOut()} id="sign-out">Log out</button>
                </div>
                : 
                <div className="not-logged-in">
                     <div className="sign-in">
                        <div className="sign-in-buttons">
                            <div className="sign-in-button" onClick={() => signInWithGoogle()}>
                                <p>Sign in with your Google account</p>
                            </div>
                            <button className="hide-message-box" onClick={() => setHideSingInMessage(!hideSingInMessage)}>Hide/Show Sign In Messages</button>
                        </div>

                        {hideSingInMessage === false &&
                        <>
                            <p>By signing in, it will allow you to sync all your tasks across all your devices.</p>
                            <p>If you do not, all the tasks you have created will only be available on the device you created it on.</p>
                            <hr />
                            <p>If you have signed in, try checking your internet connection</p> 
                        </>}
                    </div> 
                </div> }
            </div>
            <hr />
        </header>
    );
}
 
export default Header;